import type { FormTrackerStep } from "./types";

export const BOOKING_FORM_TRACKER_STEPS: FormTrackerStep[] = [
  {
    id: "tenant",
    title: "Tenant",
    label: "Personal information",
  },
  {
    id: "lease-terms",
    title: "Lease Terms",
    label: "Rental agreement details",
  },
  {
    id: "payment-plans",
    title: "Payment Plans",
    label: "Options for rent payment",
  },
  {
    id: "documents",
    title: "Documents",
    label: "Required paperwork",
  },
];

export type CommercialRenewalStepId = "renewal-terms" | "payment-plans" | "tor-rules" | "preview";

export const COMMERCIAL_RENEWAL_TRACKER_STEPS: Array<FormTrackerStep & { id: CommercialRenewalStepId }> = [
  {
    id: "renewal-terms",
    title: "Renewal Terms",
    label: "Renewal agreement details",
  },
  {
    id: "payment-plans",
    title: "Payment Plans",
    label: "Options for rent payment",
  },
  {
    id: "tor-rules",
    title: "TOR Rules",
    label: "Terms of renewal rules",
  },
  {
    id: "preview",
    title: "Preview",
    label: "Review before confirming",
  },
];
